import {
  BusinessScheduleSummary,
  BusinessScheduleDetailed,
  BusinessSchedulePayload,
} from 'types/BusinessScheduleTypes';
import useHttp from '../helpers/HttpMethods';

class BusinessScheduleService {
  static async list(): Promise<BusinessScheduleSummary[]> {
    return await useHttp().get('/business-schedules');
  }

  static async findById(id: number): Promise<BusinessScheduleDetailed> {
    return await useHttp().get(`/business-schedules/${id}`);
  }

  static async create(body: BusinessSchedulePayload): Promise<Response> {
    return await useHttp().post(body, '/business-schedules');
  }

  static async edit(id: number, body: BusinessSchedulePayload): Promise<Response> {
    return await useHttp().put(body, `/business-schedules/${id}`);
  }

  static async delete(id: number): Promise<Response> {
    return await useHttp().del(`/business-schedules/${id}`);
  }
}

export default BusinessScheduleService;
